import { useState, useRef, useCallback, useLayoutEffect } from 'react';

/** 预留：表格边框 + 横向滚动条，避免算出的 y 偏小出现多余纵向滚动条 */
const TABLE_SCROLL_Y_BUFFER = 20;

/**
 * 表格区域自适应剩余高度，返回 scroll.y（表头固定、内容滚动）
 */
export default function useTableScrollY(deps = []) {
    const tableWrapRef = useRef(null);
    const [tableScrollY, setTableScrollY] = useState(undefined);

    const updateTableScrollY = useCallback(() => {
        const wrap = tableWrapRef.current;
        if (!wrap) {
            return;
        }
        const paginationEl = wrap.querySelector('.ant-table-pagination');
        const theadEl = wrap.querySelector('.ant-table-header') || wrap.querySelector('.ant-table-thead');
        const paginationH = paginationEl
            ? paginationEl.getBoundingClientRect().height + 16
            : 48;
        const theadH = theadEl ? theadEl.getBoundingClientRect().height : 40;
        const bodyH = Math.floor(
            wrap.clientHeight - theadH - paginationH - TABLE_SCROLL_Y_BUFFER
        );
        setTableScrollY(bodyH > 80 ? bodyH : 80);
    }, []);

    useLayoutEffect(() => {
        const wrap = tableWrapRef.current;
        if (!wrap) {
            return undefined;
        }

        const scheduleUpdate = () => {
            requestAnimationFrame(() => {
                updateTableScrollY();
                // 表头/分页/横向滚动条渲染完成后再测一次
                requestAnimationFrame(updateTableScrollY);
            });
        };

        scheduleUpdate();

        const ro = new ResizeObserver(scheduleUpdate);
        ro.observe(wrap);

        // 监听表格内部结构变化（数据加载后出现表头/分页等）
        const mo = new MutationObserver(scheduleUpdate);
        mo.observe(wrap, { childList: true, subtree: true });

        window.addEventListener('resize', scheduleUpdate);
        return () => {
            ro.disconnect();
            mo.disconnect();
            window.removeEventListener('resize', scheduleUpdate);
        };
    }, [updateTableScrollY, ...deps]);

    return { tableWrapRef, tableScrollY };
}
